/** Department chips shown first in the global header browse bar. */
export const HEADER_DEPARTMENT_CHIPS = [
  { name: 'Men', icon: '👔', value: 'dept:Men', department: 'Men' },
  { name: 'Women', icon: '👗', value: 'dept:Women', department: 'Women' },
  { name: 'Babies', icon: '👶', value: 'dept:Babies', department: 'Babies' },
  { name: 'Boys', icon: '👦', value: 'dept:Boys', department: 'Boys' },
  { name: 'Girls', icon: '👧', value: 'dept:Girls', department: 'Girls' },
  { name: 'Pets', icon: '🐾', value: 'dept:Pets', category: 'Pet Supplies' },
];

/** Fashion-only chips for the pre-owned browse carousel (Items page + header bar). */
export const PRE_OWNED_BROWSE_CAROUSEL_CATEGORIES = [
  { name: 'All', icon: '🛍️', value: '' },
  { name: 'Clothing', icon: '👕', value: 'Clothing' },
  { name: 'Footwear', icon: '👟', value: 'Footwear' },
  { name: 'Bags', icon: '👜', value: 'Bags' },
  { name: 'Watches', icon: '⌚', value: 'Watches' },
  { name: 'Accessories', icon: '💍', value: 'Accessories' },
  { name: 'Beauty', icon: '💄', value: 'Beauty' },
  { name: 'Luggage', icon: '🧳', value: 'Luggage' },
];

/** Fashion Curated Finds filters — non-fashion lives under Hobbies & More. */
export const PRE_OWNED_BROWSE_FILTER_CATEGORIES = [
  ...PRE_OWNED_BROWSE_CAROUSEL_CATEGORIES,
];

/** Full header browse bar: departments first, then carousel categories. */
export const HEADER_BROWSE_CATEGORIES = [
  ...HEADER_DEPARTMENT_CHIPS,
  ...PRE_OWNED_BROWSE_CAROUSEL_CATEGORIES,
];

const DEPARTMENT_VALUES = new Set(
  HEADER_DEPARTMENT_CHIPS.map((chip) => chip.department).filter(Boolean),
);

export function getSelectedHeaderBrowseValue(searchParams) {
  const category = searchParams.get('category') || '';
  const subcategory = searchParams.get('subcategory') || '';

  if (category === 'Pet Supplies') {
    return 'dept:Pets';
  }

  if (subcategory) {
    const root = subcategory.split(' > ')[0];
    if (DEPARTMENT_VALUES.has(root)) {
      return `dept:${root}`;
    }
  }

  return category;
}

export function buildHeaderBrowseTarget(value, { pathname, searchParams }) {
  const base =
    pathname === '/defected-items'
      ? '/defected-items'
      : pathname === '/hobbies-finds'
        ? '/hobbies-finds'
        : '/pre-owned-items';
  const params = new URLSearchParams();
  const search = searchParams.get('search');
  if (search) {
    params.set('search', search);
  }

  if (!value) {
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
  }

  if (value.startsWith('dept:')) {
    const dept = value.slice(5);
    const chip = HEADER_DEPARTMENT_CHIPS.find((entry) => entry.value === value);
    if (chip?.category) {
      params.set('category', chip.category);
    } else {
      params.set('subcategory', dept);
    }
  } else {
    params.set('category', value);
    if (value !== 'Books') {
      params.delete('book_subcategory');
    }
  }

  return `${base}?${params.toString()}`;
}
